import {
  CLEAR_UNIT_UPGRADE_VERSION,
  GET_UNIT_UPGRADES_FAILURE,
  GET_UNIT_UPGRADES_REQUEST,
  GET_UNIT_UPGRADES_SUCCESS,
  GET_UNIT_VERSION_FAILURE,
  GET_UNIT_VERSION_REQUEST,
  GET_UNIT_VERSION_SUCCESS,
} from "actions/unitUpgradeVersion";

const initialState = {
  upgrades: {},
  upgradesLoading: false,
  version: [],
  versionLoading: false,
  error: null,
};

export default function unitUpgradeVersion(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_UNIT_UPGRADES_REQUEST:
      return {
        ...state,
        upgradesLoading: true,
        error: null,
      };

    case GET_UNIT_UPGRADES_SUCCESS:
      return {
        ...state,
        upgradesLoading: false,
        upgrades: payload || {},
        error: null,
      };

    case GET_UNIT_UPGRADES_FAILURE:
      return {
        ...state,
        upgradesLoading: false,
        error: payload,
      };

    case GET_UNIT_VERSION_REQUEST:
      return {
        ...state,
        versionLoading: true,
        error: null,
      };

    case GET_UNIT_VERSION_SUCCESS: {
      return {
        ...state,
        versionLoading: false,
        version: payload || [],
        error: null,
      };
    }

    case GET_UNIT_VERSION_FAILURE:
      return {
        ...state,
        versionLoading: false,
        error: payload,
      };

    case CLEAR_UNIT_UPGRADE_VERSION:
      return initialState;
    default:
      return state;
  }
}
